<template>
    <header class="relative flex items-center z-20" :class="{ 'hidden': showSpaLayout }">
        <template v-if="!ready">
            <slot></slot>
        </template>
        <div v-else class="max-w-screen-xl mx-auto flex items-center px-5 justify-between w-full py-6">
            <a :href="logoHref">
                <img class="h-10 sm:h-12" :src="logoUrl" alt="Unbundled Legal Help">
            </a>

            <div class="hidden lg:flex justify-between" v-if="showLinks">
                <nav :class="showDirectory ? 'space-x-10 xl:space-x-16' : 'space-x-16'">
                    <a v-for="link in anchorLinks" :key="link.label" class="col-span-1 text-white font-[200] text-sm/6" :href="link.href">{{ link.label }}</a>
                </nav>
            </div>

            <div class="flex items-center space-x-5">
                <img class="h-6 sm:h-9 w-auto" src="/assets/img/theme/us-flag.svg" alt="US Flag" />
                <img class="h-12 hidden sm:block" src="/assets/img/theme/10y-sign.png" alt="10 Years of Service" />

                <div v-if="!showSpaLayout && showLinks" class="h-7 w-auto flex justify-center items-center sm:hidden text-brand-blue">
                    <button type="button" @click="toggle" :aria-expanded="open" aria-label="Open menu" aria-controls="mobile-nav" class="flex items-center justify-center">
                        <svg class="h-4 w-auto text-brand-lime" viewBox="0 0 24 15" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><line x1="6.5" y1="0.5" x2="23.5" y2="0.5" stroke="#CFFC82" stroke-linecap="round"></line><line x1="0.5" y1="7.5" x2="23.5" y2="7.5" stroke="#CFFC82" stroke-linecap="round"></line><line x1="0.5" y1="14.5" x2="17.5" y2="14.5" stroke="#CFFC82" stroke-linecap="round"></line></svg>
                    </button>
                </div>
            </div>
        </div>

        <transition
            enter-active-class="transition-opacity duration-150 ease-linear"
            enter-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="transition-opacity duration-150 ease-linear"
            leave-class="opacity-100"
            leave-to-class="opacity-0"
        >
            <div v-show="open" id="mobile-nav" class="relative z-20 flex justify-center">
                <div class="fixed inset-0 z-40" @click="toggle">
                    <div class="absolute inset-0 bg-zinc-500 opacity-70"></div>
                </div>
                <div class="fixed top-0 left-0 z-50 w-full">
                    <div class="flex justify-between items-center border-b border-zinc-300 px-5 py-3 bg-brand-teal">
                        <a :href="logoHref">
                            <img class="h-10" :src="logoUrl" alt="Unbundled Legal Help">
                        </a>

                        <div class="h-7 w-auto flex justify-center sm:hidden text-brand-lime">
                            <button type="button" @click="toggle" aria-label="Close menu" class="flex items-center justify-center">
                                <svg fill="currentColor" viewBox="0 0 384 512" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>
                            </button>
                        </div>
                    </div>
                    <div class="flex bg-neutral-100 px-5 py-8">
                        <nav class="w-full grid grid-cols-2 gap-5">
                            <a v-for="link in anchorLinks" :key="link.label" class="col-span-1 text-xl font-light" :href="link.href" @click="toggle">{{ link.label }}</a>
                        </nav>
                    </div>
                </div>
            </div>
        </transition>
    </header>
</template>

<script>
import { mapGetters } from 'vuex';
import state from '../store/state';

export default {
    props: {
        logoUrl: {
            type: String,
            required: true,
        },
        logoHref: {
            type: String,
            required: true,
        },
        directoryUrl: {
            type: String,
            default: '',
        },
        anchorBaseUrl: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            ready: false,
            open: false,
            anchors: [
                { label: 'About Us', landingHash: '#who-is-unbundled', homeHash: '#what' },
                { label: 'Services', landingHash: '#sector-cards', homeHash: '#divisions' },
                { label: 'Testimonials', landingHash: '#testimonials', homeHash: '#testimonials' },
                { label: 'FAQ', landingHash: '#faqs', homeHash: '#faqs' },
            ],
        }
    },

    methods: {
        toggle() {
            this.open = !this.open;
        }
    },

    computed: {
        ...mapGetters([
            'showSpaLayout',
        ]),
        showLinks() {
            return !window.location.pathname.includes('/requests/');
        },
        showDirectory() {
            return this.directoryUrl !== '';
        },
        baseServesHomeSections() {
            return this.anchorBaseUrl.includes('://www.');
        },
        anchorLinks() {
            const links = this.anchors.map(({ label, landingHash, homeHash }) => ({
                label,
                href: this.anchorBaseUrl
                    ? `${this.anchorBaseUrl}/${this.baseServesHomeSections ? homeHash : landingHash}`
                    : landingHash,
            }));

            return this.showDirectory
                ? [...links, { label: 'Directory', href: this.directoryUrl }]
                : links;
        },
    },

    created() {
        if (! this.$store.hasModule('call')) {
            this.$store.registerModule('call', state);
        }
        this.ready = true;
    }
}
</script>
